import Booking from '@solvhealth/types/interfaces/Booking';
import Location from '@solvhealth/types/interfaces/Location';
import React, { Component } from 'react';
import styled from 'styled-components';
import {
  ADD_REVIEW_INITIAL,
  ADD_REVIEW_TO_SOLV,
  DO_YOU_HAVE_GOOGLE_ACCOUNT,
  NPS_AND_ADD_REVIEW_FLOW_RECOMMEND_TO_GOOGLE,
} from '../../../constants/index';
import {
  ADD_REVIEW_I_WOULD_NOT_RECOMMEND,
  ADD_REVIEW_I_WOULD_RECOMMEND,
} from '../../../core/analytics/events';
import { analyticsTrackEvent } from '../../../core/analytics/index';
import AddReviewWarning from '../AddReviewWarning';
import ReviewHeader from '~/components/AddReview/ReviewHeader';
import { PRIMARY_RATING } from '../../../components/LeaveAReview/components/PrimaryRatingSelector';
import withStyles from '../../../core/isomorphic-style-loader/withStyles';
import { isEmptyObject } from '../../../core/util/object';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module '../AddReview.css' or its corre... Remove this comment to see the full error message
import s from '../AddReview.css';
import LandingTransition from '../transitions/LandingTransition';
const FIVE_STAR = 5;
const FOUR_STAR = 4;
const THREE_STAR = 3;
const HIGH_NPS_SCORE = [9, 10];
const AVERAGE_NPS_SCORE = [7, 8];
const HIGH_ENOUGH_NPS_SCORE_TO_RECOMMEND = 8;

const NpsCollectionQuestion = styled.div.withConfig({ componentId: 'sc-n42ndj-0' })`
  font-size: 18px;
  text-align: center;
  margin-top: 40px;
`;

type Props = {
  bookingId: string;
  booking: Booking;
  location: Location;
  handleRatingChange: (...args: any[]) => any;
  submitReview: (...args: any[]) => any;
  submitNps: (...args: any[]) => any;
  setFlowState: (...args: any[]) => any;
  review?: string;
  error?: any;
  flowState: string;
  onStarChange: (...args: any[]) => any;
};

type State = any;

class NpsCollector extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      npsScore: null,
    };
  }

  handleWouldYouRecommendYes = (solvRating: any) => {
    const trackingProperties = {
      locationId: this.props.location.id,
      flowType: NPS_AND_ADD_REVIEW_FLOW_RECOMMEND_TO_GOOGLE,
      starRating: solvRating,
      review: this.props.review,
      bookingId: this.props.bookingId,
    };
    analyticsTrackEvent(ADD_REVIEW_I_WOULD_RECOMMEND, trackingProperties);

    this.props.submitReview(
      {
        locationId: this.props.location.id,
        bookingId: this.props.bookingId,
        providerId: this.props.booking.providerId,
        starRating: solvRating,
      },
      false
    );

    this.props.onStarChange({ value: solvRating, genre: PRIMARY_RATING });

    this.props.setFlowState(DO_YOU_HAVE_GOOGLE_ACCOUNT);
  };

  handleWouldYouRecommendNo = (solvRating: any) => {
    const trackingProperties = {
      locationId: this.props.location.id,
      flowType: NPS_AND_ADD_REVIEW_FLOW_RECOMMEND_TO_GOOGLE,
      starRating: solvRating,
      review: this.props.review,
      bookingId: this.props.bookingId,
    };

    this.props.submitReview(
      {
        locationId: this.props.location.id,
        bookingId: this.props.bookingId,
        providerId: this.props.booking.providerId,
        starRating: solvRating,
      },
      false
    );

    this.props.onStarChange({ value: solvRating, genre: PRIMARY_RATING });
    analyticsTrackEvent(ADD_REVIEW_I_WOULD_NOT_RECOMMEND, trackingProperties);

    this.props.handleRatingChange(THREE_STAR);

    this.props.setFlowState(ADD_REVIEW_TO_SOLV);
  };

  handleNpsScore = (npsScore: any) => {
    const wouldRecommendToGoogle = npsScore >= HIGH_ENOUGH_NPS_SCORE_TO_RECOMMEND;
    let solvRating = FIVE_STAR;
    if (HIGH_NPS_SCORE.includes(npsScore)) {
      solvRating = FIVE_STAR;
    } else if (AVERAGE_NPS_SCORE.includes(npsScore)) {
      solvRating = FOUR_STAR;
    } else {
      solvRating = THREE_STAR;
    }

    this.props.handleRatingChange(solvRating);
    // store nps

    this.props.submitNps({
      score: npsScore,
      bookingId: this.props.bookingId,
      locationId: this.props.location.id,
    });

    if (wouldRecommendToGoogle) {
      this.handleWouldYouRecommendYes(solvRating);
    } else {
      this.handleWouldYouRecommendNo(solvRating);
    }
  };

  npsCollection = () => (
    <div className={s.wouldYouRecommendContainer}>
      <ReviewHeader booking={this.props.booking} location={this.props.location} />

      <AddReviewWarning error={this.props.error} ratingDate={this.props.booking?.ratingDate} />
      {!isEmptyObject(this.props.location) && (
        <div>
          <NpsCollectionQuestion>
            How likely is it that you would recommend <br />
            {this.props.location.displayNamePrimary} to a friend or family member?
          </NpsCollectionQuestion>

          <div className={s.legend}>
            <div>Not likely </div>

            <div>Very likely </div>
          </div>

          <div className={s.npsGrid}>
            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((rating) => (
              <div
                className={this.state.npsScore === rating ? s.npsSelected : null}
                key={rating}
                onClick={() => {
                  this.setState({ npsScore: rating });
                }}
              >
                {rating}
              </div>
            ))}
          </div>

          <button
            className={this.state.npsScore !== null ? s.continue : s.continueDisabled}
            disabled={this.state.npsScore === null || typeof this.state.npsScore === 'undefined'}
            onClick={() => this.handleNpsScore(this.state.npsScore)}
          >
            Continue
          </button>
        </div>
      )}
    </div>
  );

  render() {
    return (
      <LandingTransition
        flowState={this.props.flowState}
        stateToActivateFlow={ADD_REVIEW_INITIAL}
        toRender={this.npsCollection}
      />
    );
  }
}

export default withStyles(s)(NpsCollector);
